import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    mode: "out-in",
    "enter-active-class": "animated fadeIn u-anim-dur-300",
    "leave-active-class": "animated fadeOut u-anim-dur-300"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("span", { key: _ctx.value }, _toDisplayString(_ctx.value), 1))
    ]),
    _: 1
  }))
}